<script setup>
import { nextTick } from 'vue';

const props = defineProps({
  editorRef: {
    type: Object,
    required: true,
  },
});

// Definir categorias de variáveis disponíveis
const shortcuts = [
  {
    label: 'Filial',
    icon: 'fa-solid fa-building',
    color: 'info',
    items: [
      { label: 'Razão social', template: '{{movimento.filial.razao}}' },
      { label: 'Nome', template: '{{movimento.filial.nome}}' },
      { label: 'Fantasia', template: '{{movimento.filial.fantasia}}' },
      { label: 'CNPJ', template: '{{movimento.filial.cnpj}}' },
      { label: 'IE', template: '{{movimento.filial.getInscricaoEstadual}}' },
      { label: 'Endereço', template: '{{movimento.filial.endereco}}' },
      { label: 'Número', template: '{{movimento.filial.numero}}' },
      { label: 'Complemento', template: '{{movimento.filial.complemento}}' },
      { label: 'Cidade', template: '{{movimento.filial.cidade}}' },
      { label: 'UF', template: '{{movimento.filial.uf}}' },
      { label: 'CEP', template: '{{movimento.filial.cep}}' },
      { label: 'Telefone 1', template: '{{movimento.filial.telefone}}' },
      { label: 'Email comercial', template: '{{movimento.filial.emailComercial}}' },
      { label: 'Tipo IE', template: '{{movimento.filial.tipoIe}}' },
    ],
  },
  {
    label: 'Cliente',
    icon: 'fa-solid fa-user',
    color: 'success',
    items: [
      { label: 'Código', template: '{{movimento.pessoa.codigo}}' },
      { label: 'Nome', template: '{{movimento.pessoa.nome}}' },
      { label: 'Fantasia', template: '{{movimento.pessoa.fantasia}}' },
      { label: 'Endereço', template: '{{movimento.pessoa.endereco}}' },
      { label: 'Número', template: '{{movimento.pessoa.numero}}' },
      { label: 'Complemento', template: '{{movimento.pessoa.complemento}}' },
      { label: 'Ponto de referência', template: '{{movimento.pessoa.pontoReferencia}}' },
      { label: 'Bairro', template: '{{movimento.pessoa.bairro}}' },
      { label: 'Cidade', template: '{{movimento.pessoa.cidade}}' },
      { label: 'UF', template: '{{movimento.pessoa.uf}}' },
      { label: 'CEP', template: '{{movimento.pessoa.cep}}' },
      { label: 'Física / Jurídica', template: '{{movimento.pessoa.fisicaJuridica}}' },
      { label: 'CNPJ/CPF', template: '{{movimento.pessoa.cnpj}}' },
      { label: 'Inscrição', template: '{{movimento.pessoa.inscricao}}' },
      { label: 'Telefone 1', template: '{{movimento.pessoa.fone1}}' },
      { label: 'Telefone 2', template: '{{movimento.pessoa.fone2}}' },
      { label: 'Celular', template: '{{movimento.pessoa.celular}}' },
      { label: 'Email', template: '{{movimento.pessoa.email}}' },
      { label: 'Email Nfe', template: '{{movimento.pessoa.emailNfe}}' },
      { label: 'Tipo', template: '{{movimento.pessoa.tipo}}' },
      { label: 'Tipo IE', template: '{{movimento.pessoa.tipoIE}}' },
      { label: 'Observação', template: '{{movimento.pessoa.observacao}}' },
      { label: 'Contato', template: '{{movimento.pessoa.contato}}' },
    ],
  },
  {
    label: 'Movimento',
    icon: 'fa-solid fa-receipt',
    color: 'warning',
    items: [
      { label: 'Referência interna', template: '{{movimento.referenciaInterna}}' },
      { label: 'Sequência', template: '{{movimento.sequencia}}' },
      { label: 'Tipo', template: '{{movimento.tipo}}' },
      { label: 'Data', template: '{{movimento.data}}' },
      { label: 'Data formatada', template: '{{movimento.getData}}' },
      { label: 'Qtde produtos', template: '{{movimento.qtdeProdutos}}' },
      { label: 'Total produtos', template: '{{movimento.totalProdutos}}' },
      { label: 'Total produtos formatado', template: '{{movimento.getTotalProdutos}}' },
      { label: 'Total desconto', template: '{{movimento.totalDesconto}}' },
      { label: 'Total desconto formatado', template: '{{movimento.getTotalDesconto}}' },
      { label: 'Total final', template: '{{movimento.totalFinal}}' },
      { label: 'Total final formatado', template: '{{movimento.getTotalFinal}}' },
      { label: 'Observação', template: '{{movimento.observacao}}' },
      { label: 'Código do caixa', template: '{{movimento.caixa__Codigo}}' },
      { label: 'Informações complementares', template: '{{movimento.informacoesComplementares}}' },
      { label: 'Peso líquido', template: '{{movimento.pesoLiquido}}' },
      { label: 'Peso bruto', template: '{{movimento.pesoBruto}}' },
      { label: 'Valor frete', template: '{{movimento.valorFrete}}' },
      { label: 'Total da comissão', template: '{{movimento.totalComissao}}' },
      { label: 'Total da promoção', template: '{{movimento.totalPromocao}}' },
      { label: 'Total outro', template: '{{movimento.valorOutro}}' },
      { label: 'Valor desconto e promoção', template: '{{movimento.getTotalDescontoAndPromocao}}' },
      { label: 'Data de saída', template: '{{movimento.dataSaida}}' },
      { label: 'Efetivado', template: '{{movimento.efetivado}}' },
      { label: 'Desefetivado', template: '{{movimento.desefetivado}}' },
      { label: 'Efetivado financeiro', template: '{{movimento.efetivadoFinanceiro}}' },
      { label: 'Efetivado financeiro data', template: '{{movimento.efetivadoFinanceiroData}}' },
      { label: 'Efetivado financeiro formatada(dd/mm/yyyy)', template: '{{movimento.formattedEfetivadoFinanceiroData}}' },
      { label: 'Efetivado estoque', template: '{{movimento.efetivadoEstoque}}' },
      { label: 'Efetivado estoque data', template: '{{movimento.efetivadoEstoqueData}}' },
      { label: 'Efetivado estoque formatada(dd/mm/yyyy)', template: '{{movimento.formattedEfetivadoEstoqueData}}' },
      { label: 'Modelo entrada', template: '{{movimento.notaEntradaModelo}}' },
      { label: 'Série entrada', template: '{{movimento.notaEntradaSerie}}' },
      { label: 'Nota entrada', template: '{{movimento.notaEntrada}}' },
      { label: 'Chave de acesso da entrada', template: '{{movimento.notaEntradaChaveAcesso}}' },
      { label: 'Data original da entrada', template: '{{movimento.notaEntradaEmissao}}' },
      { label: 'Data recebimento da entrada', template: '{{movimento.notaEntradaRecebimento}}' },
      { label: 'Informações complementares', template: '{{movimento.informacoesComplementaresPrintNfe}}' },
    ],
  },
  {
    label: 'Fotos do Movimento',
    icon: 'fa-solid fa-images',
    color: 'dark',
    items: [
      { label: 'Uso em v-for', template: 'v-for="(fotoMovimento) in movimento.fotosMovimentoDav"' },
      { label: 'Foto', template: '{{fotoMovimento.getFoto}}' },
    ],
  },
  {
    label: 'Vendedor',
    icon: 'fa-solid fa-handshake',
    color: 'danger',
    items: [
      { label: 'Código', template: '{{movimento.vendedor.codigo}}' },
      { label: 'Nome', template: '{{movimento.vendedor.nome}}' },
    ],
  },
  {
    label: 'Operação',
    icon: 'fa-solid fa-cogs',
    color: 'secondary',
    items: [
      { label: 'Código', template: '{{movimento.operacao.codigo}}' },
      { label: 'Nome', template: '{{movimento.operacao.nome}}' },
      { label: 'Descrição', template: '{{movimento.operacao.descricao}}' },
      { label: 'Tipo', template: '{{movimento.operacao.tipo}}' },
      { label: 'Entrada/Saída', template: '{{movimento.operacao.entradaSaida}}' },
      { label: 'Observações', template: '{{movimento.operacao.obsFiscais}}' },
      { label: 'Observações da NFC-e', template: '{{movimento.operacao.obsNFCe}}' },
    ],
  },
  {
    label: 'MovimentoProduto',
    icon: 'fa-solid fa-cubes',
    color: 'primary',
    items: [
      { label: 'Uso em v-for', template: 'v-for="(movimentoProduto) in movimento.produtosOnlyEntradaSaida"' },
      { label: 'Linha', template: '{{movimentoProduto.linha}}' },
      { label: 'Nome', template: '{{movimentoProduto.produto.nome}}' },
      { label: 'Código', template: '{{movimentoProduto.produto.codigo}}' },
      { label: 'Qtde', template: '{{movimentoProduto.qtde}}' },
      { label: 'Qtde decimal', template: '{{movimentoProduto.produto.qtdeDecimal}}' },
      { label: 'Qtde formatada', template: '{{movimentoProduto.getStrQtde}}' },
      { label: 'Unidade de medida', template: '{{movimentoProduto.produto.unidadeMedida.codigo}}' },
      { label: 'Valor unitário', template: '{{movimentoProduto.valorUnit}}' },
      { label: 'Valor unitário formatado', template: '{{movimentoProduto.getValorUnitToStringMask}}' },
      { label: 'Valor final', template: '{{movimentoProduto.valorFinal}}' },
      { label: 'Valor final formatado', template: '{{movimentoProduto.getValorFinal}}' },
      { label: 'Preço decimal', template: '{{movimentoProduto.precoDecimal}}' },
      { label: 'Foto', template: '{{movimentoProduto.fotosProdutosDav.getFoto}}' },
      { label: 'Qtde via fator de conversão', template: '{{movimentoProduto.getQtdeViaFator}}' },
      { label: 'Qtde ou Qtde via fator de conversão', template: '{{movimentoProduto.getQtdeOuQtdeViaFator}}' },
    ],
  },
  {
    label: 'Formas de Pagamento',
    icon: 'fa-solid fa-credit-card',
    color: 'info',
    items: [
      { label: 'Descrição (gridFormaPagamentoLancada)', template: '{{financeiro.descricao}}' },
      { label: 'Valor (gridFormaPagamentoLancada)', template: '{{financeiro.getValor}}' },
      { label: 'Tipo (gridFormaPagamentoLancada)', template: '{{financeiro.tipo}}' },
      { label: 'Vencimento', template: '{{financeiro.vencimento}}' },
      { label: 'Valor', template: '{{financeiro.getValor}}' },
      { label: 'Qtde cartão', template: '{{financeiro.cartaoQtde}}' },
      { label: 'Número do parcelamento', template: '{{financeiro.parcelamentoNumero}}' },
      { label: 'Descrição da forma de pagamento', template: '{{financeiro.formaPagamento.descricao}}' },
      { label: 'Tipo da forma de pagamento', template: '{{financeiro.formaPagamento.tipo}}' },
      { label: 'Tipo de parcelamento', template: '{{financeiro.formaPagamento.tipoParcelamento}}' },
      { label: 'Dividir', template: '{{financeiro.formaPagamento.dividirEm}}' },
      { label: 'Qtde max parcelas', template: '{{financeiro.formaPagamento.parcelaQtdeMax}}' },
      { label: 'Dia base', template: '{{financeiro.formaPagamento.diaBase}}' },
      { label: 'Número do cheque', template: '{{financeiro.chequeNumero}}' },
      { label: 'Cheque de terceiros', template: '{{financeiro.chequeTerceiro}}' },
      { label: 'Agência do cheque', template: '{{financeiro.chequeAgencia}}' },
      { label: 'Conta do cheque', template: '{{financeiro.chequeConta}}' },
      { label: 'Código do banco', template: '{{financeiro.banco__Codigo}}' },
      { label: 'Nome do banco', template: '{{financeiro.banco.nome}}' },
      { label: 'Código da admin do cartão', template: '{{financeiro.administradoraCartao.codigo}}' },
      { label: 'Nome da admin do cartão', template: '{{financeiro.administradoraCartao.nome}}' },
      { label: 'Tipo da admin do cartão', template: '{{financeiro.administradoraCartao.tipo}}' },
      { label: 'Código da conta bancária', template: '{{financeiro.formaPagamento.contaBancaria.codigo}}' },
      { label: 'Nome da conta bancária', template: '{{financeiro.formaPagamento.contaBancaria.nome}}' },
      { label: 'Código da carteira da conta bancária', template: '{{financeiro.formaPagamento.contaBancariaCarteira.codigo}}' },
      { label: 'Carteira da conta bancária', template: '{{financeiro.formaPagamento.contaBancariaCarteira.carteira}}' },
      { label: 'Convênio da conta bancária', template: '{{financeiro.formaPagamento.contaBancariaCarteira.convenio}}' },
      { label: 'Nome formatado da conta bancária', template: '{{financeiro.formaPagamento.contaBancariaCarteira.getNomeFormat}}' },
    ],
  },
  {
    label: 'NF-e / NFC-e',
    icon: 'fa-solid fa-cogs',
    color: 'secondary',
    items: [
      { label: 'Número', template: '{{movimento.nfe.numeroNota}}' },
      { label: 'Número formatado', template: '{{movimento.nfe.numeroNotaFormatted}}' },
      { label: 'Série', template: '{{movimento.nfe.serie}}' },
      { label: 'Modelo', template: '{{movimento.nfe.modelo}}' },
      { label: 'Modelo formatado', template: '{{movimento.nfe.getModelo}}' },
      { label: 'Situação', template: '{{movimento.nfe.nfeSituacao}}' },
      { label: 'Situação formatada', template: '{{movimento.nfe.getTitle}}' },
      { label: 'Chave de acesso', template: '{{movimento.nfe.chaveAcesso}}' },
      { label: 'Chave de acesso formatada', template: '{{movimento.nfe.getChaveAcessoFormatada}}' },
      { label: 'Tipo de emissão da NFC-e', template: '{{movimento.nfe.tipoEmissaoNfce}}' },
      { label: 'Protocolo de autorização', template: '{{movimento.nfe.protocoloAutorizacao}}' },
      { label: 'Data de autorização', template: '{{movimento.nfe.dataAutorizacao}}' },
      { label: 'Data de autorização formatada (dd/mm/yyyy)', template: '{{movimento.nfe.formattedDataAutorizacao}}' },
      { label: 'Data de inutilização', template: '{{movimento.nfe.dataInutilizada}}' },
      { label: 'Data de inutilização formatada (dd/mm/yyyy)', template: '{{movimento.nfe.formattedDataInutilizada}}' },
      { label: 'Data de cancelamento', template: '{{movimento.nfe.dataCancelamento}}' },
      { label: 'Data de cancelamento formatada (dd/mm/yyyy)', template: '{{movimento.nfe.formattedDataCancelamento}}' },
      { label: 'Url de consulta', template: '{{movimento.nfe.urlConsultaNfce}}' },
      { label: 'Código do status', template: '{{movimento.nfe.codigoStatus}}' },
      { label: 'Data de saída', template: '{{movimento.nfe.dataSaida}}' },
      { label: 'Tipo de documento', template: '{{movimento.nfe.tipoDocumento}}' },
      { label: 'Cancelado', template: '{{movimento.nfe.cancelado}}' },
    ],
  },
];

async function insertTemplate(template) {
  // Aguardar o próximo tick do Vue para garantir que tudo está renderizado
  await nextTick();

  // props.editorRef JÁ é o componente exposto (não é uma ref!)
  const codeEditorComponent = props.editorRef;

  // Tentar obter o editor de diferentes formas
  let editorInstance = null;

  // Forma 1: via getEditor() - método exposto pelo CodeEditorApp
  if (codeEditorComponent?.getEditor && typeof codeEditorComponent.getEditor === 'function') {
    editorInstance = codeEditorComponent.getEditor();
  }

  // Forma 2: via editor.value - editor é uma ref exposta
  if (!editorInstance && codeEditorComponent?.editor?.value) {
    editorInstance = codeEditorComponent.editor.value;
  }

  // Forma 3: via editor direto (fallback)
  if (!editorInstance && codeEditorComponent?.editor && codeEditorComponent.editor.state) {
    editorInstance = codeEditorComponent.editor;
  }

  if (editorInstance && editorInstance.state && editorInstance.dispatch) {
    try {
      const currentPos = editorInstance.state.selection.main.head;

      editorInstance.dispatch({
        changes: {
          from: currentPos,
          to: currentPos,
          insert: template,
        },
        selection: { anchor: currentPos + template.length },
      });

      editorInstance.focus();
    } catch (error) {
      console.error('Erro ao inserir template:', error);
    }
  } else {
    console.warn('Editor não encontrado ou inválido.', {
      codeEditorComponent,
      editor: codeEditorComponent?.editor,
    });
  }
}
</script>

<template>
  <div class="template-shortcuts pb-0">
    <div class="btn-group-wrapper">
      <div v-for="category in shortcuts" :key="category.label" class="btn-group me-2 mb-2" role="group">
        <button type="button" class="btn btn-sm" :class="`btn-outline-${category.color}`" :data-bs-toggle="category.items.length > 0 ? 'dropdown' : ''" :aria-expanded="false" :title="`Inserir variáveis de ${category.label}`">
          <i :class="category.icon"></i>
          {{ category.label }}
          <i v-if="category.items.length > 0" class="fa-solid fa-chevron-down ms-1"></i>
        </button>

        <ul class="dropdown-menu">
          <li v-for="(item, idx) in category.items" :key="idx">
            <a class="dropdown-item" href="#" @click.prevent="insertTemplate(item.template)">
              {{ item.label }}
              <span class="text-muted float-end" style="font-size: 0.75em;">{{ item.template }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.template-shortcuts {
  padding: 10px 0;
}

.btn-group-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dropdown-menu {
  max-height: 400px;
  overflow-y: auto;
}

.dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  padding: 0.5rem 1rem;
}

.dropdown-item:hover {
  background-color: #e9ecef;
}

/* Responsivo para mobile */
@media (max-width: 768px) {
  .btn-group-wrapper {
    flex-direction: column;
  }

  .btn-group {
    width: 100%;
  }

  .btn {
    width: 100%;
  }
}
</style>
